import { type MotionValue } from 'motion/react'
import { type ReactNode } from 'react'
import {
  StickyViewHeader,
  StickyViewHeaderMain,
  StickyViewHeaderExtras,
} from '@/components/StickyViewHeader'
import { Button } from '@/components/Button'
import { TabBar, TabItem } from '@/components/TabBar'
import { type BundleArchivedFilterOptions } from '@/features/admin/bundle/BundleStore'

export interface BundleManagerHeaderProps {
  scrollOffset: MotionValue<number>
  heading: ReactNode
  currentArchivedStatusTab: BundleArchivedFilterOptions
  onArchivedStatusTabChange: (tab: BundleArchivedFilterOptions) => void
  onAddBundle: () => void
}

export function BundleManagerHeader({
  scrollOffset,
  heading,
  currentArchivedStatusTab,
  onArchivedStatusTabChange,
  onAddBundle,
}: BundleManagerHeaderProps) {
  return (
    <StickyViewHeader
      bordered
      scrollOffset={scrollOffset}
      tabBar={
        <TabBar align="left">
          <TabItem
            active={currentArchivedStatusTab === 'Active'}
            onPress={() => onArchivedStatusTabChange('Active')}
            testId="bundle-manager-tab-active"
          >
            Active
          </TabItem>
          <TabItem
            active={currentArchivedStatusTab === 'Archived'}
            onPress={() => onArchivedStatusTabChange('Archived')}
            testId="bundle-manager-tab-archived"
          >
            Archived
          </TabItem>
        </TabBar>
      }
    >
      <StickyViewHeaderMain>{heading}</StickyViewHeaderMain>
      <StickyViewHeaderExtras>
        <AddBundleButton onAddBundle={onAddBundle} />
      </StickyViewHeaderExtras>
    </StickyViewHeader>
  )
}

interface AddBundleButtonProps {
  onAddBundle: () => void
}

function AddBundleButton({ onAddBundle }: AddBundleButtonProps) {
  return (
    <Button
      label="Add Bundle"
      type="submit"
      testId="add-bundle-header-button"
      onPress={onAddBundle}
    />
  )
}
